<template>
  <div v-if="user">

    <ValidationObserver ref="observer" v-slot="{ invalid }">
      <div class="box">
        <div class="flex flex-wrap items-end justify-between border-b border-theme-200 light:border-theme-600 pb-2">
          <p class="text-2xl font-bold leading-none" v-if="user.roles">{{ user.name }} ({{ user.roles.map(r => r.name).join(',') }})</p>
          <button type="button" class="btn btn-orange text-xs text-black" @click="$router.push('/profile/details')">
            <i class="fas fa-arrow-left"></i>
            <span class="ml-1">Back</span>
          </button>
        </div>

        <div class="flex flex-wrap -mx-2 mt-4">
          <div class="w-full md:w-1/2 px-2">
            <label class="block text-xs font-bold mb-2" for="full-name">Name</label>
            <ValidationProvider
              rules="required"
              name="full name"
              v-slot="{ errors }"
            >
              <input
                name="full-name"
                type="text"
                id="full-name"
                class="form-control"
                v-model="user.name"
              >
              <span class="text-sm text-red-500">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <div class="w-full md:w-1/2 px-2">
            <label class="block text-xs font-bold mb-2" for="email">Email</label>

            <ValidationProvider
              :rules="emailValidation.rules"
              name="cheque number"
              v-slot="{ errors }"
            >
              <input
                name="email"
                type="email"
                id="email"
                class="form-control"
                v-model="user.email"
              >
              <span class="text-sm text-red-500">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
        </div>

        <div class="flex flex-wrap -mx-2 mt-4">
          <div class="w-full md:w-1/2 px-2">
            <label class="block text-xs font-bold mb-2" for="password">Password</label>
              <ValidationProvider
                vid="password"
                name="password"
                v-slot="{ errors }"
              >
                <div class="flex items-center">
                  <input
                    ref="password"
                    name="password"
                    :type="passwordType"
                    id="password"
                    class="form-control form-no-outline h-10 border-r-0 rounded-r-none"
                    v-model="password"
                  >
                  <button
                    type="button"
                    class="h-10 px-5 btn-blue rounded-r focus:outline-none"
                    @click="togglePasswordType(passwordType, 'password')"
                  >
                    <i class="fas" :class="passwordType === 'password' ? 'fa-eye' : 'fa-eye-slash'"></i>
                  </button>
                </div>
                <span class="text-sm text-red-500">{{ errors[0] }}</span>
              </ValidationProvider>
          </div>
          <div class="w-full md:w-1/2 px-2">
            <label class="block text-xs font-bold mb-2" for="password-confirmation">Password confirmation</label>
              <ValidationProvider
                rules="confirmed:password"
                name="password confirmation"
                v-slot="{ errors }"
              >
                <div class="flex items-center">
                  <input
                    ref="password-confirmation"
                    name="password-confirmation"
                    :type="confirmPaswordType"
                    id="password-confirmation"
                    class="form-control form-no-outline h-10 border-r-0 rounded-r-none"
                    v-model="passwordConfirmation"
                  >
                  <button
                    type="button"
                    class="h-10 px-5 btn-blue rounded-r focus:outline-none"
                    @click="togglePasswordType(confirmPaswordType, 'confirm')"
                  >
                    <i class="fas" :class="confirmPaswordType === 'password' ? 'fa-eye' : 'fa-eye-slash'"></i>
                  </button>
                </div>
                <span class="text-sm text-red-500">{{ errors[0] }}</span>
              </ValidationProvider>

          </div>
        </div>

        <div class="flex flex-wrap -mx-2 mt-12 justify-end" v-if="!isAdmin">
          <div class="w-full md:w-1/2 px-2">
            <label class="block text-xs font-bold mb-2" for="password">Current password</label>
            <div class="flex items-center">
              <ValidationProvider
                rules="required"
                name="current password"
                v-slot="{ errors }"
              >
                <input
                  name="current-password"
                  :type="currentPaswordType"
                  id="current-password"
                  class="form-control form-no-outline h-10 border-r-0 rounded-r-none"
                  v-model="currentPassword"
                >
                <span class="text-sm text-red-500">{{ errors[0] }}</span>
              </ValidationProvider>
              <button
                type="button"
                class="h-10 px-5 btn-blue rounded-r focus:outline-none"
                @click="togglePasswordType(currentPaswordType, 'current')"
              >
                <i class="fas" :class="currentPaswordType === 'password' ? 'fa-eye' : 'fa-eye-slash'"></i>
              </button>
            </div>
          </div>
        </div>


        <div class="box p-2 pt-8 flex flex-wrap justify-end items-center">
          <button
            type="button"
            class="btn btn-reset"
            @click="reset"
          >
            <i class="fa-xs fas fa-undo"></i>
            <span class="ml-1">RESET</span>
          </button>
          <button
            type="button"
            class="btn btn-save"
            @click="save"
          >
            <i class="fa-xs fas fa-check"></i>
            <span class="ml-2">UPDATE</span>
          </button>
        </div>

      </div>
    </ValidationObserver>

  </div>
</template>


<script>
import axios from 'axios'
import { mapGetters } from 'vuex'

export default {
  props: {
    createAlert: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      editID: null,
      user: {},
      roles: [],
      currentPassword: '',
      password: '',
      passwordConfirmation: '',
      status: '',
      currentPaswordType: 'password',
      passwordType: 'password',
      confirmPaswordType: 'password',
    }
  },
  computed: {
    emailValidation() {
      let rules = 'required'
      let delay = 0
      if (this.User.email !== this.user.email) {
        rules = 'required|email-available'
        delay = 450
      }
      return {rules, delay}
    },
    ...mapGetters({
      config: 'config/config',
      User: 'user/user',
      isAdmin: 'user/isAdmin',
    })
  },
  mounted() {
    this.setMode()
  },
  methods: {
    togglePasswordType(type, field) {
      const inputType = type  === 'password' ? 'text' : 'password'

      switch (field) {
      case 'current':
        this.currentPaswordType = inputType
        break
      case 'password':
        this.passwordType = inputType
        break
      case 'confirm':
        this.confirmPaswordType = inputType
        break
      }

    },
    setMode() {
      this.getRoles()
      this.get()
    },
    emptyUser() {
      return {
        name: '',
        email: '',
        roles: [],
      }
    },
    reset() {
      this.$swal.fire({
        title: 'Reset Form',
        text: 'Are you sure?',
        type: 'question',
        confirmButtonText: 'Yes',
        showCancelButton: true,
        cancelButtonText: 'Cancel',
      })
        .then((result) => {
          if (result.value) {
            this._reset()
          }
        })
    },
    _reset() {
      this.user = {}
      this.roles = []
      this.currentPassword = ''
      this.password = ''
      this.passwordConfirmation = ''
      this.getRoles()
      this.get()
    },
    async save () {
      const isValid = await this.$refs.observer.validate()
      if (!isValid) {
        this.$notify({type: 'error', title: 'Form has errors'})
        return
      }
      this._save()
    },
    _save() {
      if (this.password !== this.passwordConfirmation) {
        this.$swal.fire({
          title: 'Error',
          text: 'Passwords do not match',
          type: 'error',
        })
        return
      }

      this.user.current_password = this.currentPassword
      this.user.change_password = this.password

      this.user.role_names = this.user.roles.map(r => r.name)
      // update
      axios.put('users/' + this.user.id, this.user)
        .then(() => {
          this.currentPassword = ''
          this.password = ''
          this.passwordConfirmation = ''
          this.$swal.fire({
            title: 'Done',
            text: 'Profile updated successfully!',
            type: 'success',
          })
          this.$emit('updated', this.user)
          this.status = 'none'
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getRoles() {
      axios.get('users/roles')
        .then((response) => {
          this.roles = Object.assign([], response.data)
        })
        .catch((error) => {
          console.log(error.response)
          this.$swal.fire({
            title: 'Profile not found',
            type: 'warning',
          })
        })
    },
    get() {
      axios.get('users/' + this.User.id)
        .then((response) => {
          this.user = Object.assign({}, response.data)
        })
        .catch((error) => {
          console.log(error.response)
          this.$swal.fire({
            title: 'Profile not found',
            type: 'warning',
          })
        })
    },
  }
}
</script>
